import { NuxtAxiosInstance } from '@nuxtjs/axios';

// eslint-disable-next-line import/no-mutable-exports
let axiosInstance: NuxtAxiosInstance;

export function initializeAxios(axios: NuxtAxiosInstance) {
  axiosInstance = axios;
}

export { axiosInstance };
